import { background } from "../background";
import { fn as welcome } from "./tasks/welcome";
import { fn as load } from "../installer"
import {returnScreen} from "../gui";
import { sleep } from "../../util/sleep";
import { ProcessManager } from "../../41worker/ProcessManager";

export async function boot() {
    let backgroundError: Error | undefined
    try {
        background()
    } catch(e) {
        backgroundError = (e as Error)
    }
    const screen = returnScreen()
    if (process.env.NODE_ENV === "development") {
        //console.log("screen", document.getElementsByClassName("boot")[0])
        window.PlatformUtility._boot = screen
    }
    if (backgroundError) {
        screen.write("An error occurred while running background tasks", ["error"])
        screen.write(backgroundError.message, ["error", "blink"])
    }
    const write = (text: string, features?: string[]) => screen.write(text, features)
    await welcome({ write })
    await load({ write })

    await sleep(3000);
    const pm = ProcessManager.getInstance();
    pm.createProcess("C:/Pluto/System41/init.js", "", {})
}